module.exports = __webpack_public_path__ + "img/silent-night.24039c95.jpeg";